import {
  SearchMainScreen,
  SearchRecentScreen,
  SearchSavedScreen,
} from '../screens';

const searchRoutes = [
  {
    path: 'main',
    component: SearchMainScreen,
    title: 'Search',
    hasChild: true,
  },
  {
    path: 'recent',
    component: SearchRecentScreen,
    title: 'Recent',
  },
  {
    path: 'saved',
    component: SearchSavedScreen,
    title: 'Saved',
  },
];

export default searchRoutes;
